/// <amd-module name="typeahead/core/message/MoreSuggestionsClickedMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class MoreSuggestionsClickedMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.more_suggestions_clicked";
    }

    constructor(private e: BaseJQueryEventObject,
                private readonly suggestions: any[],
                private readonly lob: string) {
    }

    public getRenderedSuggestions(): any[] {
        return this.suggestions;
    }

    public getLob(): string {
        return this.lob;
    }

    public getEvent(): BaseJQueryEventObject {
        return this.e;
    }

    public getTopic(): string {
        return MoreSuggestionsClickedMessage.getTopic();
    }
}
